import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * ErrorState Component - Display when API calls fail or data cannot be loaded
 *
 * @example
 * <app-atom-error-state
 *   message="Failed to load data"
 *   submessage="Please try again later">
 * </app-atom-error-state>
 */
@Component({
  selector: 'app-atom-error-state',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './error-state.component.html',
  styleUrls: ['./error-state.component.scss'],
})
export class ErrorStateComponent {
  message = input<string>('Failed to load data');
  submessage = input<string>('Please try again or contact support if the problem persists.');
}
